import {useState} from 'react';
import {toast} from 'react-toastify';
import {parkCurrentCart} from '../infrastructure/parkedCartApi';
import {isSuccess} from '../../common/domain/RemoteData.model';

/**
 * Acción de aparcar el carrito activo (compartida por el preview del navbar y el
 * checkout): las líneas pasan al guardado del cliente efectivo y el carrito queda
 * vacío. Sin reconcile después: el carrito vacío no lo admite.
 * onParked se ejecuta solo si el aparcado fue bien (típicamente recargar el carrito).
 */
export const useParkCart = (onParked) => {
    const [parking, setParking] = useState(false);

    const parkCart = async () => {
        setParking(true);
        try {
            const result = await parkCurrentCart();
            if (isSuccess(result)) {
                await onParked?.();
                toast.success('Carrito guardado. Lo tienes en "Carritos guardados".');
            } else {
                toast.error('No se pudo guardar el carrito');
            }
        } catch (error) {
            console.error('Failed to park cart:', error);
            toast.error('No se pudo guardar el carrito');
        } finally {
            setParking(false);
        }
    };

    return {parkCart, parking};
};
